export const environment = {
  production: false,
  API: {
    SAMHITA_ONDC: {
      BASE_URL: 'https://samhita-wo-c-backend-pre-prod.samhita.org/api',
      END_POINT: {
        V1: {
          SIGNUP: '/v1/auth/signup',
          PHONE_PASSWORD_LOGIN: '/v1/auth/login/phone',
          EMAIL_PASSWORD_LOGIN: '/v1/auth/login/email',
          OTP_LOGIN: '/v1/auth/login/otp',
          REQUEST_OTP: '/v1/auth/request-otp',
          USER_DETAILS: '/v1/users/me',
          WORK_EXPERIENCES: '/v1/profiles/me/work-experience',
          GET_S3_SIGNED_URL: '/v1/s3/get-signed-url',
          USER_PROFILE : '/v1/profiles/me',
          CREATE_PROFILE : '/v1/profiles/',
          WORK_OPPORTUNITY_TRANSACTION : '/v1/',
          SEARCH_JOBS : '/v1/ondc_client/search',
          SELECT_JOB : '/v1/ondc_client/select',
          INIT_JOB : '/v1/ondc_client/init',
          CONFIRM_JOB : '/v1/ondc_client/confirm',
          STATUS_JOB : '/v1/ondc_client/status',
          CANCEL_JOB : '/v1/ondc_client/cancel',
          UPDATE_JOB : '/v1/ondc_client/update',
          ISSUE_JOB : '/v1/ondc_client/issue',
          SETTLE_JOB : '/v1/ondc_client/settle',
          ISSUE_STATUS : '/v1/ondc_client/issue_status',
          GET_MY_JOBS : '/v1/ondc_client/confirm-jobs',
          GET_ISSUES : '/v1/ondc_client/existing_issue',
          SEARCH_JOB_CACHE : '/v1/ondc_client/search_cache',
          CLEAR_SEARCH_CACHE : '/v1/ondc_client/clear_search_cache',
          OFF_NETWORK_JOBS : '/v1/off_network_jobs/',
          APPLY_OFF_NETWORK_JOB : '/v1/off_network_jobs/apply/',
          MY_OFF_NETWORK_JOBS : '/v1/off_network_jobs/my_jobs/',
          SEND_UNIVERSAL_OTP : '/v1/auth/send_otp_universal/',
          VERIFY_UNIVERSAL_OTP : '/v1/auth/verify_otp_universal/',
          SSO_LOGIN : '/v1/auth/sso',
          CHECK_USER_EXISTENCE : '/v1/auth/check_if_user_exists/',
          AUTH_2_URL: '/v1/auth/get_oauth2_url',
          OAUTH_TOKEN_DETAILS : '/v1/auth/oauth2/callback',
          GET_NEW_PROFILE : '/v1/profiles_new/me',
          CREATE_NEW_PROFILE : '/v1/profiles_new/',
          UPDATE_NEW_PROFILE: '/v1/profiles_new/me',
        }
      },
    },
    AUS: {
      BASE_URL: 'https://aus-samhita-backend.samhita.org/v1',
      END_POINT: {
        GET_ADDRESS_BY_PINCODE: '/location/',
        GET_BANK_INFO_BY_IFSC: '/bank_details_by_ifsc/',
      }
    },
    UIM : {
      BASE_URL: 'https://uim-samhita-backend.samhita.org',
      END_POINT: {
        V3 : {}
      }
    },
    AZURE_SERVICE: {
      BASE_URL: 'https://api.cognitive.microsofttranslator.com',
      END_POINT: {
        LANGUAGES: '/languages',
        TRANSLATE: '/translate'
      },
      AZURE_API_KEY : 'CmMx1ljtLlHupG3rOxQV1Mad8vkmpmb436Ny9yUKiwsn1UCEjQKIJQQJ99BCACGhslBXJ3w3AAAbACOGA3P5',
      REGION: 'centralindia'
    }
  },
  userRoleId: {
    ADMIN: '473dc1e2-4c48-4f26-b1b5-70f727f3185b',
    END_USER: '45a68245-6b27-45c1-9af0-af07a49a7305'
  },  
  URLS: {
    SAMHITA_APP: 'https://uim-samhita-dev.samhita.org'
  },
  SECRET_KEY: "3YfSZk7gwmQ5ezIv3MUSPNmufgMSC7Wy",
  SECRET_IV: "1020304050607080"
}
